import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import AccountsDialog from "@/components/dialogs/AccountsDialog.vue";
import ProductsViewModel from "@/viewmodels/app/ProductsViewModel";
import CreditSimuilatorDialog from "@/components/dialogs/CreditSimuilatorDialog.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductsComponent',
  setup(__props) {

const accountsDialogRef = ref(null);
const simulatorDialogRef = ref(null);
const viewModel = new ProductsViewModel(accountsDialogRef, simulatorDialogRef);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_breadcrumbs, {
              class: "text-caption py-0 px-0",
              items: _unref(viewModel).breadcrumbs
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "mdi-chart-bar",
                  size: "small"
                })
              ]),
              _: 1
            }, 8, ["items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewModel).services.value, (service) => {
          return (_openBlock(), _createBlock(_component_v_col, {
            cols: "12",
            sm: "6",
            md: "4",
            lg: "3",
            key: service.title
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                height: "100%",
                flat: "",
                border: "",
                class: "text-center pa-3 d-flex flex-column justify-between text-center",
                style: {"border-left":"7px solid rgb(var(--v-theme-primary), 0.4)"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    color: "primary",
                    icon: service.icon,
                    size: "30",
                    class: "mb-3 mx-auto"
                  }, null, 8, ["icon"]),
                  _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(service.title), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_card_text, { class: "text-subtitle-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(service.description), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        variant: "tonal",
                        width: "100%",
                        color: "primary",
                        class: "text-none",
                        onClick: ($event: any) => (_unref(viewModel).handleServiceClick(service))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(service.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(AccountsDialog, {
      ref_key: "accountsDialogRef",
      ref: accountsDialogRef
    }, null, 512),
    _createVNode(CreditSimuilatorDialog, {
      ref_key: "simulatorDialogRef",
      ref: simulatorDialogRef
    }, null, 512)
  ], 64))
}
}

})